<div [class]="'flex flex-row gap-(--gap-relaxed) overflow-x-hidden w-full py-(--space-4) px-0 mt-(--space-4)'">
  @for (item of cardItems; track $index; let i = $index) {
    <p-skeleton width="25rem" height="10rem" [style.opacity]="getSkeletonOpacity(i)" />
  }
</div>
<div [class]="'flex flex-col gap-(--gap-relaxed) mt-(--space-6)'">
  @for (item of lineItems; track $index; let i = $index) {
    <p-skeleton width="100%" height="3rem" [style.opacity]="getSkeletonOpacity(i)" />
  }
</div>
